module.exports = __webpack_public_path__ + "img/bpt.323ab46f.svg";